fragment practiceRecordingFocusPointDetails on PracticeRecordingFocusPointType {
  id
  moment
  aliyah {
    id
    parashah {
      transliteratedTitle
    }
    rank
  }
  haftarah {
    parashah {
      transliteratedTitle
    }
    reading {
      id
    }
  }
  sentenceGroup {
    reading {
      id
      description
    }
  }
  sentence {
    id
    sefariaId
    text
  }
  segmentedSentence {
    id
    segments {
      index
      words
    }
  }
}

fragment practiceRecordingSegmentPointDetails on PracticeRecordingSegmentPointType {
  id
  moment
  sentence {
    id
  }
  segmentIndex
}

fragment practiceRecordingDetails on PracticeRecordingType {
  id
  created
  modified
  uploadedAt
  processingSuccess
  processingMessage
  notes
  shared
  readOrder
  voice
  pronunciation {
    id
    description
  }
  torahMelody {
    id
    description
  }
  haftarahMelody {
    id
    description
  }
  sentenceGroupMelody {
    id
    description
  }
  listenedAt
  focusPoints {
    ...practiceRecordingFocusPointDetails
  }
  segmentPoints {
    ...practiceRecordingSegmentPointDetails
  }
}
